var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNurse = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M27 13v-2h-2V9h-2v2h-2v2h2v2h2v-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m31.32 16.767 1.978-5.606c.536-1.52-.228-3.24-1.829-3.747C29.61 6.824 26.57 6 24 6s-5.61.824-7.47 1.414c-1.6.508-2.364 2.228-1.828 3.747l1.98 5.606a8 8 0 1 0 14.638 0M24 8c-2.24 0-5.029.738-6.865 1.32-.46.146-.73.658-.547 1.176l2.024 5.734c3.587-1.14 7.19-1.14 10.776 0l2.024-5.734c.183-.518-.087-1.03-.547-1.175C29.03 8.738 26.24 8 24 8m5.806 10.481a1 1 0 0 1-.157-.045c-3.774-1.415-7.524-1.415-11.298 0a1 1 0 0 1-.157.045 6.001 6.001 0 1 0 11.685 2.714 6 6 0 0 0-.073-2.714",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M34 34h2v2h-2v2h-2v-2h-2v-2h2v-2h2z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M16.879 28S6 31.393 6 35.467V42h36v-6.533C42 31.393 31.121 28 31.121 28l-5.972 4.193a2 2 0 0 1-2.298 0zm14.562 2.22-5.142 3.61a4 4 0 0 1-4.597 0l-5.143-3.61a38 38 0 0 0-4.227 1.776c-1.296.646-2.482 1.363-3.316 2.092C8.115 34.875 8 35.343 8 35.467V40h32v-4.533c0-.124-.115-.592-1.016-1.38-.834-.728-2.02-1.445-3.317-2.092a38 38 0 0 0-4.226-1.775",
  clipRule: "evenodd"
})));
export { SvgNurse as ReactComponent };
export default __webpack_public_path__ + "assets/images/nurse.svg";